const newAdminUrl = "https://inbot-new-admin.in.bot/numeros-whatsapp?bot_id=";

export function NumbersDisabled() {
    return (
        <div className="container-trigger width-95-perc" style={{ padding: "10px 0px" }}>
            <h1 style={{ fontSize: "23px", fontWeight: "bolder", color: "#004488", width: "100%" }} className="title_2024">Gestão de Números WhatsApp</h1>
            <div className="column-align" style={{ width: "97%", alignItems: "center" }}>
                <div className="hr_color" style={{ width: "100%", marginTop: "15px" }}></div>
            </div>
            <div className="div_color" style={{ width: "80%", textAlign: "left", marginTop: "20px" }}>
                <div style={{ background: "#FFF", padding: "35px", borderRadius: "6px" }}>
                    <span><strong>Esta tela foi desativada.</strong></span>
                    <br />
                    <br />
                    <span>A gestão de números WhatsApp (listagem, cadastro e alteração) agora é feita no novo admin da InBot. Utilize a nova tela para consultar e manter os números configurados.</span>
                    <br />
                    <br />
                    <div className="column-align" style={{ textAlign: "center", alignItems: "center" }}>
                        <button className="button-blue" onClick={() => window.open(newAdminUrl, "_blank")} style={{ width: "260px" }}>Abrir no novo admin</button>
                        <br />
                        <a href={newAdminUrl} target="_blank" rel="noopener noreferrer">{newAdminUrl}</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NumbersDisabled;
